module.exports = __webpack_public_path__ + "img/backgroundLogin.551c1f93.png";